export default __webpack_public_path__ + "static/media/Servicos.6afe5868.svg";